import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmReportsCustomCreateRoute } from '@jira/router-routes__servicedesk-reports-routes/src/csmReportsCustomCreateRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { reportsCustomCreatePageEntryPoint } from './common/reportsCustomCreatePage.entrypoint.tsx';

const csmReportsCustomCreatePageEntryPoint = createPageEntryPoint({
	main: reportsCustomCreatePageEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmReportsCustomCreateRouteEntry: Route = createEntry(
	csmReportsCustomCreateRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'service-management.reports.custom-create',
		layout: serviceProjectLayout,

		navigation: {
			sidebarId: SidebarIdCsmApp,
		},

		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
		],

		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmReportsCustomCreatePageEntryPoint
				: notFoundPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
